import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const MenuLazy = loadable(() => import(/* webpackChunkName: "PagesLight" */ './Menu'));

export const MenuAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <MenuLazy />
    </DelayedSuspense>
);
